module.exports = __webpack_public_path__ + "img/7.451bde8.png";